// Layout persistant par défaut de chaque page : la coquille AppShell, en
// variante application, blog ou devise selon les props.
// Une page peut le remplacer en déclarant `Page.layout = …`.
import type { Page } from '@inertiajs/core'
import AppShell from '@/layouts/AppShell'

export function resolveLayout(_name: string, _page: Page): unknown {
  return AppShell
}
